import { createAction, props } from '@ngrx/store';
import { ClientInterfaceWithId } from '@sk/sk-interfaces';


export const loadClients = createAction('[Clients] Load Clients');

export const loadClientsSuccess = createAction(
  '[Clients] Load Clients Success',
  props<{ clients: ClientInterfaceWithId[] }>()
);

export const loadClientsFailure = createAction(
  '[Clients] Load Clients Failure',
  props<{ error: any }>()
);


export const addClient = createAction(
  '[Clients] add client',
  props<{ client: ClientInterfaceWithId }>()
);


export const removeClient = createAction(
  '[Clients] removed',
  props<{
    id: string,
  }>()
);


export const updateClient = createAction(
  '[Clients] update',
  props<{
    id: string,
    changes: Partial<ClientInterfaceWithId>
  }>()
);


export const updateSuccess = createAction(
  '[Clients] update success',
  props<any>()
);

export const updateError = createAction(
  '[Clients] update failed',
  props<{ error: Error }>()
);


export const addSuccess = createAction(
  '[Clients] added with success',
  props<any>()
);

export const addError = createAction(
  '[Clients] added failed',
  props<{ error: Error }>()
);


export const queryFireStoreClients = createAction(
  '[Clients] query clients',
  props<any>()
);

export const queryFireStoreClientsError = createAction(
  '[Clients] erraor at query clients',
  props<{error : Error}>()
);


export const fromFireStoreAddClient = createAction(
  '[Clients] added by Firestore',
  props<{ client: ClientInterfaceWithId }>()
);


export const fromFireStoreModifyClient = createAction(
  '[Clients] modified by Firestore',
  props<{ client: ClientInterfaceWithId }>()
);
export const fromFireStoreRemoveClient = createAction(
  '[Clients] removed by Firestore',
  props<{
    id: string,
  }>()
);



